export default __webpack_public_path__ + "static/media/houseimage3.86d1b69e.png";